import { ProductCategory } from '../types';

// Ordered list of product categories with their Cyrillic display labels.
// Labels are passed through the t() transliteration helper at render time.
export const PRODUCT_CATEGORIES: { value: ProductCategory; label: string }[] = [
  { value: 'melem', label: 'Мелем' },
  { value: 'med', label: 'Мед' },
  { value: 'balzam', label: 'Балзам' },
  { value: 'ulje', label: 'Уље' },
  { value: 'sapun', label: 'Сапун' },
];

const LABEL_BY_VALUE: Record<string, string> = PRODUCT_CATEGORIES.reduce(
  (acc, c) => { acc[c.value] = c.label; return acc; },
  {} as Record<string, string>
);

// categoryLabel returns the Cyrillic label for a category value, or the raw
// value if it's unknown (so custom/legacy values still render something).
export function categoryLabel(value: string): string {
  return LABEL_BY_VALUE[value] || value;
}
